import React, { createContext, useContext, useEffect, useState } from "react";

const PGIModeContext = createContext();

export const usePGIMode = () => useContext(PGIModeContext);
export function ContextPGIMode({ children }) {
  const [mode, setMode] = useState(false);
  const [previousRoute, setPreviousRoute] = useState(null);
  const setPreviousRouteHandler = (route) => {
    setPreviousRoute(route);
  };

  const handleChangeMode = (value) => {
    setMode(value);
  };

  useEffect(() => {}, []);

  useEffect(() => {}, []);

  const collection = {
    mode,
    handleChangeMode,
    previousRoute,
    setPreviousRouteHandler,
  };
  return (
    <PGIModeContext.Provider value={collection}>
      {children}
    </PGIModeContext.Provider>
  );
}
